/**
 * Created by claudio iozzia on 07/07/2017.
 */
import {Ic} from "../../../models/common";
import {Utils} from "../../../common/utils";

export class NumLEDBounds {
  private static MAX_DEF_SERIE: Number = 20;
  private static MAX_DEF_PARAL: Number = 1;

  readonly series: number;
  readonly parallel: number;

  static getIt(ic: Ic): NumLEDBounds {
    return new NumLEDBounds(ic);
  }

  constructor (ic: Ic) {
    this.series   = Utils.getFieldValue(ic, "validator.led.maxSeries",   NumLEDBounds.MAX_DEF_SERIE);
    this.parallel = Utils.getFieldValue(ic, "validator.led.maxParallel", NumLEDBounds.MAX_DEF_PARAL);
  }
}
